<form id="userExtractForm" [formGroup]="form" autocomplete="off">
  <div class="d-lg-flex align-items-center mb-2">
    <div class="d-flex align-items-center">
      <label class="control-label required me-2">{{'i18n.domain.reports.filter.fields.startDate' | translate}}:</label>
      <ejs-datepicker #startTime
                      formControlName="startDate"
                      format="dd.MM.yyyy"
                      class="me-2"
                      id="startDate">
      </ejs-datepicker>
    </div>
    <div class="d-flex align-items-center">
      <label class="control-label required me-2">{{'i18n.domain.reports.filter.fields.endDate' | translate}}:</label>
      <ejs-datepicker #endTime
                      formControlName="endDate"
                      format="dd.MM.yyyy"
                      class="me-2"
                      id="endDate">
      </ejs-datepicker>
    </div>
  </div>
</form>
